import React from 'react';
import { classNames } from '../../utils/classNames';

type IconButtonVariant = 'ghost' | 'solid';

type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: IconButtonVariant;
  badge?: number | boolean;
};

const variantStyles: Record<IconButtonVariant, string> = {
  ghost:
    'text-[var(--app-text-muted)] hover:text-primary-500 hover:bg-[var(--app-hover)] focus-visible:ring-primary-500 focus-visible:ring-offset-[var(--app-ring-offset)] focus-visible:ring-offset-2',
  solid:
    'bg-primary-500 text-white hover:bg-primary-600 focus-visible:ring-primary-500 focus-visible:ring-offset-[var(--app-ring-offset)] focus-visible:ring-offset-2',
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, children, variant = 'ghost', badge, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          'relative inline-flex h-10 w-10 items-center justify-center rounded-full transition duration-200 focus:outline-none focus-visible:ring-2',
          variantStyles[variant],
          className
        )}
        {...props}
      >
        {children}
        {badge ? (
          <span className="absolute -top-0.5 -right-0.5 inline-flex h-4 min-w-[1rem] animate-[pop_200ms_ease-out] items-center justify-center rounded-full bg-danger text-[10px] font-semibold text-white shadow" >
            {typeof badge === 'number' ? badge : ''}
          </span>
        ) : null}
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;

